import { render } from "./AiProcessesListPage.vue?vue&type=template&id=4a0dcad1"
import script from "./AiProcessesListPage.vue?vue&type=script&lang=js"
export * from "./AiProcessesListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__